<template>
  <div
    id="panel"
    class="panel"
  >
    <div class="panel-title">
      <p>调查问卷管理</p>
    </div>
    <div class="panel-content center_content">
      <div class="course_info">
        <div class="panel-title">
          <p v-if="lessonInfo">{{ lessonInfo ? lessonInfo.title : '' }}</p>
          <p v-if="lessonInfo">负责人:{{ managerName }}</p>
        </div>
        <div class="course_btn">
          <div
            class="add-btn"
            style="margin-bottom:0;"
            @click="showAddWindow"
          >添加调查问卷</div>
          <!-- <router-link
            tag="div"
            :to="'/www/lesson_detail?id=' + lessonInfo.id"
            class="add-btn"
          >预览</router-link> -->
          <!-- <div
            v-if="lessonInfo.status==0"
            class="add-btn"
            @click="$parent.saveOnline(lessonInfo.title, lessonInfo.id)"
          >提交审核</div> -->
        </div>
      </div>

      <div id="list">
        <table>
          <tbody>
            <tr class="l_header">
              <th class="itemStatus">问卷名称</th>
              <th class="itemStatus">创建时间</th>
              <th class="itemStatus">发布时间</th>
              <th class="itemStatus">状态</th>
              <th
                class="action"
                style="width: 200px;"
              >操作</th>
            </tr>
            <tr
              class="item"
              v-for="(item,index) in tableData"
              :key="index"
            >
              <td class="itemStatus">{{ item.title }}</td>
              <td class="itemStatus">{{ formatDate(item.created) }}</td>
              <td class="itemStatus">{{ item.status == 1 ? formatDate(item.pubDate) : '' }}</td>
              <td class="itemStatus">{{ item.status == 1 ? '已发布' : '未发布' }}</td>
              <td class="action">
                <a
                  href="javascript:;"
                  class="status_1"
                  style="text-decoration: none;"
                  v-if="item.status == 0"
                  @click="toDetail(item)"
                >维护</a>
                <a
                  href="javascript:;"
                  class="delete"
                  style="text-decoration: none;"
                  v-if="item.status == 0"
                  @click="delSurvey(item)"
                >删除</a>
                <a
                  class="edit"
                  href="javascript:;"
                  style="text-decoration: none;"
                  @click="querySingle(item.id)"
                >编辑</a>
                <a
                  href="javascript:;"
                  :style="item.status == 1 ? 'color:gray;' : 'color:green'"
                  style="text-decoration: none;"
                  @click="pubSurvey(item)"
                >{{item.status == 1 ? '取消发布' : '发布'}}</a>
                <a
                  class="edit"
                  href="javascript:;"
                  style="text-decoration: none;"
                  v-if="item.status == 1"
                  @click="toResult(item)"
                >查看结果</a>
              </td>
            </tr>
          </tbody>
        </table>
        <div
          class="noitems"
          v-if="!tableData.length"
        >没有数据</div>
      </div>
      <!-- 分页 -->
      <pagination
        :cur='pageInfo.page'
        :all='pageInfo.all'
        :totalData="pageInfo.totalData"
        :callback="pageCallback"
      ></pagination>
    </div>
    <div
      class="form_overlay"
      style="z-index: 2;"
      :style="classShowAddWindow"
    >
      <div class="form_overlay_bg"></div>
      <div class="form_panel">
        <div class="form_title">调查问卷管理</div>
        <div class="form_content">
          <form id="itemForm">
            <div class="item">
              <span class="label"><i class="require">*</i>名称:</span>
              <input
                type="text"
                v-model="formInfo.title"
                autocomplete="off"
                maxlength="25"
              >
            </div>
          </form>
        </div>
        <div class="form_control">
          <a
            href="javascript:;"
            class="button close"
            id="form_close"
            @click="hideAddWindow"
          >取消</a>
          <a
            href="javascript:;"
            class="button"
            id="form_submit"
            @click="saveInfo"
          >提交</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Pagination from '../../../components/Pager'

export default {
  name: 'OnlineResearch',
  components: {
    Pagination
  },
  props: [
    'lessonInfo'
  ],
  data() {
    return {
      queryInfo: {
        page: 1,
        size: 10,
        lessonOnline_id: this.$route.query.id
      },
      formInfo: {
        id: 0,
        lessonOnline_id: this.$route.query.id,
        title: ''
      },
      tableData: [],
      tableDataCount: 0,
      classShowAddWindow: {}
    }
  },
  methods: {
    // 分页
    pageCallback(data) {
      this.queryInfo.page = data
      this.search()
    },
    // 时间格式化
    formatDate(value) {
      return value ? value.replace('T', ' ').substring(0, value.indexOf('.')) : ''
    },
    // 新建弹窗
    showAddWindow() {
      this.classShowAddWindow = {
        visibility: 'visible'
      }
    },
    hideAddWindow() {
      this.classShowAddWindow = {}
      this.formInfo = {
        id: 0,
        lessonOnline_id: this.$route.query.id,
        title: ''
      }
    },
    async search() {
      await this.$http.get('/online_survey/', {
        params: this.queryInfo
      }).then((data) => {
        this.tableData = data.results
        this.tableDataCount = data.count
      }).catch(() => {
        this.$layer.msg('获取数据失败！')
      })
    },
    // 编辑时查询
    async querySingle(id) {
      const url = '/online_survey/' + id + '/'
      await this.$http.get(url).then((data) => {
        this.formInfo.id = data.id
        this.formInfo.title = data.title
        this.classShowAddWindow = {
          visibility: 'visible'
        }
      }).catch((error) => {
        console.log(error)
        this.$parent.showMsg('数据获取失败！')
      })
    },
    async saveInfo() {
      if (!this.formInfo.title) {
        this.$layer.msg('请填写调查问卷名称！')
        return
      }
      if (this.formInfo.id) {
        const url = '/online_survey/' + this.formInfo.id + '/'
        await this.$http.put(url, this.formInfo).then((data) => {
          if (data.id) {
            this.$parent.showMsg('修改成功！')
            this.hideAddWindow()
            this.search()
          } else {
            this.$parent.$parent.showMsg('修改失败！')
          }
        }).catch((error) => {
          console.log(error)
          this.$parent.showMsg('修改失败！')
        })
      } else {
        await this.$http.post('/online_survey/', this.formInfo).then((data) => {
          if (data.id) {
            this.$parent.showMsg('添加成功！')
            this.hideAddWindow()
            this.search()
          } else {
            this.$parent.showMsg('添加失败！')
          }
        }).catch((error) => {
          console.log(error)
          this.$parent.showMsg('添加失败！')
        })
      }
    },
    delSurvey (item) {
      this.$parent.showConfirm('确定要删除吗？', async () => {
        await this.$http.put('/online_survey/' + item.id + '/', {
          isdel: 1
        }).then((data) => {
          this.search()
        }).catch((error) => {
          console.log(error)
        })
      })
    },
    async pubSurvey (item) {
      if (item.status === 0) {
        const checkData = await this.$http.get('/online_survey/', {
          params: {
            lessonOnline_id: this.$route.query.id,
            status: 1
          }
        })
        if (checkData.results.length > 0) {
          this.$layer.msg('只能发布一个调查问卷！')
          return false
        }
      }
      const pubDate = new Date()
      pubDate.setHours(pubDate.getHours() + 8)
      this.$parent.showConfirm('确定要' + (item.status === 0 ? '' : '取消') + '发布吗？', async () => {
        await this.$http.put('/online_survey/' + item.id + '/', {
          status: 1 - item.status,
          pubDate: pubDate
        }).then((data) => {
          this.search()
        }).catch((error) => {
          console.log(error)
        })
      })
    },
    toDetail (item) {
      this.$router.push('/online/research/detail?id=' + this.$route.query.id + '&survey_id=' + item.id)
    },
    toResult (item) {
      this.$router.push('/online/research/result?id=' + this.$route.query.id + '&survey_id=' + item.id)
    }
  },
  mounted() {
    this.search()
  },
  computed: {
    pageInfo() {
      return {
        page: this.queryInfo.page,
        all: Math.ceil(this.tableDataCount / this.queryInfo.size),
        totalData: this.tableDataCount
      }
    },
    managerName() {
      return this.lessonInfo.manager && this.lessonInfo.manager ? this.lessonInfo.manager.name : ''
    }
  }
}
</script>

<style scoped src="@/assets/css/project-detail.css"></style>

<style lang="less" scoped>
.panel-content {
  padding: 20px 40px;
}
.c-content {
  margin: 0;
  transform: translate(-50%, -50%);
}
.itemStatus {
  img {
    width: 120px;
  }
}
#c-panel {
  z-index: 2;
}
.c-content {
  min-height: 650px;
}
.active {
  color: #266dc7 !important;
  text-decoration: underline;
}
.course_info {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  .panel-title {
    p {
      display: inline-block;
      margin-right: 20px;

      &:last-child {
        color: #999;
        font-size: 16px;
      }
    }
  }
  .course_btn {
    div {
      margin-left: 20px;
      padding: 7px 20px;
      background: #73D6CA;
      color: #fff;
      border-radius: 3px;
      &:first-child {
        background: #25c7a8;
      }
      &:nth-child(2) {
        border: 1px solid #73D6CA;
        color: #73D6CA;
        background: #fff;
      }
    }
  }
}
.crumb_nav {
  color: #999;
  margin-top: 20px;
}
.add-btn {
  width: unset;
  height: unset;
  line-height: normal;
}
</style>
